var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.6667 0H5.33333C1.92889 0 0 1.92889 0 5.33333V14.6667C0 18.0622 1.92 20 5.33333 20H14.6667C18.0711 20 20 18.0622 20 14.6667V5.33333C20 1.92889 18.0711 0 14.6667 0Z",
    fill: "#9DA3BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3205 10.7083H10.7495V13.257C10.7495 13.6673 10.4139 14 10 14C9.58605 14 9.25048 13.6673 9.25048 13.257V10.7083H6.67954C6.29342 10.6687 6 10.3461 6 9.96132C6 9.5765 6.29342 9.25394 6.67954 9.2143H9.24242V6.67365C9.28241 6.29088 9.60778 6 9.99597 6C10.3842 6 10.7095 6.29088 10.7495 6.67365V9.2143H13.3205C13.7066 9.25394 14 9.5765 14 9.96132C14 10.3461 13.7066 10.6687 13.3205 10.7083Z",
    fill: "#9DA3BB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNew);
export default __webpack_public_path__ + "static/media/add_new.109a1f4ab5ed620fe1b96d1f737cff30.svg";
export { ForwardRef as ReactComponent };